import React, { useContext, useEffect, useState } from 'react';

import { ProjectContext } from '@core/context';
import useClassy from '@core/hooks/useClassy';
import useEnvInfo from '@core/hooks/useEnvInfo';
import useMediaQuery from '@core/hooks/useMediaQuery';
import { useProjectStore } from '@core/store';

import classes from '../../style.module.scss';
import { useDarkMode, useLogo } from '../../utils/hooks';

const LogoLink = () => {
  const bem = useClassy(classes, 'Header');
  const { project } = useContext(ProjectContext);
  const { name: projectTitle } = project;
  const { src: srcForLightScheme, whiteSrc: srcForDarkScheme, logoLink } = useLogo();
  const userScheme = useDarkMode();
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [logoSrc, setLogoSrc] = useState(srcForLightScheme || srcForDarkScheme);
  const { isClient } = useEnvInfo();

  const [headerType, logoSize, projectLayout] = useProjectStore(s => [
    s.data.appearance.header.type,
    s.data.appearance.logo.size,
    s.data.appearance.layout.style,
  ]);

  const allowLargeLogo = projectLayout === 'classic' || projectLayout === 'modern';

  useEffect(() => {
    // avoid SSR hydration errors where we have mismatches between the img src
    // on the server and client, since we can't access media query or local
    // storage results on the server
    if (isClient) {
      setLogoSrc(
        headerType !== 'line'
          ? srcForLightScheme || ''
          : userScheme === 'light' || (userScheme === 'system' && !prefersDarkMode)
            ? srcForLightScheme || ''
            : srcForDarkScheme || srcForLightScheme || '',
      );
    }
  }, [headerType, isClient, prefersDarkMode, srcForLightScheme, userScheme, srcForDarkScheme]);

  return (
    <a className={bem('rm-Logo', '-logo')} href={logoLink} target="_self">
      <img
        alt={projectTitle}
        className={bem(
          'rm-Logo-img',
          allowLargeLogo && logoSize === 'large' && 'rm-Logo-img_lg',
          '-logo-img',
          !allowLargeLogo && '-logo-img_small',
        )}
        src={logoSrc}
      />
    </a>
  );
};

export default LogoLink;
